import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { PinActivation } from "./PinActivation";

export default function PinActivationWatcher() {
  const [open, setOpen] = useState(false);
  const userData = useSelector((state) => state.userProfile.dataFetched || state.userProfile.user);
  const token = localStorage.getItem("konnect_token");

  useEffect(() => {
    if (token && userData && userData.smsVerified && !userData.hasTransPin) {
      setOpen(true);
    } else {
      setOpen(false);
    }
  }, [userData, token]);

  if (!token || !userData || !userData.smsVerified || userData.hasTransPin) {
    return null;
  }

  return (
    <PinActivation
      open={open}
      toClose={() => setOpen(false)}
      accountId={userData?.accountId}
    />
  );
}
